import { ApiError } from '../../lib/api';

/** «Не про вас» — раздел открытия не показываем (не партнёр, нет права, старый бэк): 401 / 403 / 404. */
export function isNotForViewer(e: unknown): boolean {
  return e instanceof ApiError && (e.status === 401 || e.status === 403 || e.status === 404);
}

/** Повтор запросов раздела: один — только на сбой сервера/сети; любой 4xx сразу без повтора. */
export function retryOpeningQuery(failureCount: number, e: Error): boolean {
  return failureCount < 1 && !(e instanceof ApiError && e.status < 500);
}
